import { BaseService } from "services/_baseService";

class TriggerTypesAdminService extends BaseService<any> {
    constructor() {
        super(`trigger-types`);
    }
}

export default new TriggerTypesAdminService();
